// extracted by mini-css-extract-plugin
export var cardIcon = "_ax-4";
export var checkboxCard = "_ax-0";
export var checkboxCardSelected = "_ax-3";
export var disabled = "_ax-1";
export var outerBorder = "_ax-2";
export var spacerMedium = "_ax-7";
export var spacerSmall = "_ax-6";
export var spacerXsmall = "_ax-5";